//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import TimePicker from 'src/components/Pickers/Time';
import moment from 'moment';
import { DAYS } from 'src/boot/constants';
import { i18n } from 'boot/i18n';
export default {
  components: {
    TimePicker: TimePicker
  },
  props: {
    value: {
      type: Object,
      default: function _default() {
        return {
          value: 0,
          label: i18n.t('days.sunday').substring(0, 3),
          slots: [{
            start: '9:00',
            end: '17:00'
          }]
        };
      }
    }
  },
  data: function data() {
    return {
      minutesTotal: 0
    };
  },
  computed: {
    days: function days() {
      return DAYS;
    },
    day: {
      get: function get() {
        return this.value;
      },
      set: function set(val) {
        this.$emit('input', val);
      }
    },
    hasError: function hasError() {
      if (this.day.slots.length > 1) {
        var start1 = moment(this.day.slots[0].start, 'HH:mm');
        var end1 = moment(this.day.slots[0].end, 'HH:mm');
        var start2 = moment(this.day.slots[1].start, 'HH:mm');
        var end2 = moment(this.day.slots[1].end, 'HH:mm');
        return start1.isBefore(end2) && start2.isBefore(end1);
      }

      return false;
    }
  },
  methods: {
    removeSlot: function removeSlot() {
      if (this.day.slots.length > 1) {
        var day = this.day;
        day.slots.pop();
        this.day = day;
      }
    },
    addSlot: function addSlot() {
      if (this.day.slots.length === 1) {
        var day = this.day;
        day.slots.push({
          start: '18:00',
          end: '20:00'
        });
        this.day = day;
      }
    },
    onSlotChange: function onSlotChange(val, slot, type) {
      val = moment(val, 'HH:mm');
      var day = this.day; // Adjust start/end hours within the same slot

      if (type === 'start') {
        if (val.isAfter(moment(day.slots[slot].end, 'HH:mm'))) {
          day.slots[slot].end = val.format('HH:mm');
        }
      } else {
        if (val.isBefore(moment(day.slots[slot].start, 'HH:mm'))) {
          day.slots[slot].start = val.format('HH:mm');
        }
      }

      day.slots[slot][type] = val.format('HH:mm');
      this.day = day;
    }
  }
};